import { atom } from "jotai"
import { createStorefrontClient } from "@shopify/hydrogen"

import { rootLoaderDataAtom } from "./loaders"
import { siteLoaderDataAtom } from "./loaders"

export const storefrontAtom = atom(get => {
  const { site } = get(siteLoaderDataAtom)
  const { storefrontApiVersion, shop } = get(rootLoaderDataAtom)

  const locale = new Intl.Locale(site.locale)

  const { storefront } = createStorefrontClient({
    storefrontApiVersion,
    storeDomain: shop.shopifyDomain,
    publicStorefrontToken: shop.publicStorefrontToken,
    i18n: {
      language: locale.language.toUpperCase() as any,
      country: (locale.region?.toUpperCase() ?? "AU") as any,
    },
  })

  return storefront
})
